import {
  FETCH_MARKETS,
  FETCH_ACTIVE_MARKETS,
  FETCH_MARKET_BRANDS,
  SELECT_MARKET,
  MARKET_LOADING,
  FETCH_DASHBOARD_DATA,
} from '../actions/markets';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_MARKETS: {
      const allMarkets = action.payload || [];
      const activeMarkets = allMarkets.filter((market) => market.status === 'Active');
      return {
        ...state,
        markets: allMarkets,
        activeMarkets,
      };
    }
    case FETCH_ACTIVE_MARKETS:
      return {
        ...state,
        activeMarkets: action.payload,
      };
    case FETCH_MARKET_BRANDS:
      return {
        ...state,
        marketBrands: action.payload,
      };
    case SELECT_MARKET:
      return {
        ...state,
        selectedMarket: action.payload,
      };
    case MARKET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case FETCH_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload,
      };
    default:
      return state;
  }
}
